import {withTranslation} from "react-i18next";
import React, {useEffect,useState} from "react";
import {Button, Form, Input, Modal, Tooltip, Alert} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import config from "../../../../_config/config";
import {xcService} from "../../../../_services/xcService";
import variables from "../../../../_constants/variables";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";


function InviteUser(props) {
    const {t,  userProfile, type} =props;
    const [formInvite] = Form.useForm();
    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);


    const copyLink = (name, link) => {
        navigator.clipboard.writeText(formInvite.getFieldValue(link))
        setShow(true);
        setMessage(name + " " + t("iscopy"));
    }

    useEffect(( ) => {
        if (userProfile){
            const {setFieldsValue, getFieldValue} = formInvite;

            setFieldsValue({centerCode: userProfile.code, passwordCenter: userProfile.passcode, enlace: config.frontendUrl+props.link});

        }
    },[userProfile,formInvite])

    const onClose = (e) => {
        setShow(false);
        setMessage("")
    };

    const sendInvite = () => {

        let mPayload = {centerCode: formInvite.getFieldValue("centerCode"),
            passwordCenter: formInvite.getFieldValue("passwordCenter"), enlace: formInvite.getFieldValue("enlace"), email: formInvite.getFieldValue("email")}
        xcService.postToken(`/v1/${userType==="CENTER" ? 'center' : 'tutor'}/invite/${type}`, mPayload).then(data => {
            setShow(true);
            setMessage(t("invitesended"));

        })
    }

    return <>
        <Modal className={"modalName modal-question modal-question--tutor"} title={t("tutores.informes.titlemodal")}
               centered
               visible={props.showInviteUserModal}
               onCancel={() => props.setShowInviteUserModal(false)}
        >
            <Form className="authForm allHeightMobile"
                  name="formInvite"
                  form={formInvite}
                  layout="vertical"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
            >
                <p>{t("tutores.informes.subtitlemodal")}</p>
                <Form.Item

                    name="centerCode"
                    label={<div>
                        <span className={"text-label"}>{t("registro.codigoc")}</span>&nbsp;&nbsp;
                        <Tooltip title={t("registro.tooltipcodigo")}>
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </div>}
                    >
                    <Input placeholder={t("registro.codigoc")} />
                  </Form.Item>
                <Form.Item  style={{ marginBottom: "0px" }}>
                 <Button onClick={() => copyLink(t("registro.codigoc"),"centerCode")}  className="btnWhiteBlue modal-question--button" htmlType="button">{t("tutores.informes.copy")}</Button>
                </Form.Item>
                <Form.Item
                    name="passwordCenter"
                    label={<div>
                        <span className={"text-label"}>{t("registro.clave")}</span>&nbsp;&nbsp;
                        <Tooltip title={t("registro.tooltipclave")}>
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </div>}>
                    <Input.Password
                        placeholder={t("registro.clavep")}
                    />
                </Form.Item>
                <Form.Item   style={{ marginBottom: "0px" }}><Button onClick={() => copyLink(t("registro.clave"),"passwordCenter")}   className="btnWhiteBlue  modal-question--button" htmlType="button">{t("tutores.informes.copy")}</Button></Form.Item>
                {/*{errorCenter &&
                            <Row><Col span={24}>
                                <Alert message={t("registro.errorCenter")} type="error" />
                            </Col></Row>
                        }*/}
                <Form.Item
                    label={<div>
                        <span className={"text-label"}>{t("tutores.informes.titleemail")}</span>&nbsp;&nbsp;
                        <p>{t("tutores.informes.textinvite")}</p>
                    </div>}
                    name="email"

                >

                    <Input placeholder={t("tutores.informes.placeinvite")}/>

                </Form.Item>
                <Form.Item  style={{ marginBottom: "0px" }}><Button className="btnWhiteBlue  modal-question--button"
                                            onClick={() => sendInvite()}

                                                                    htmlType="button">{t("tutores.informes.sendinvitation")}</Button></Form.Item>
                <Form.Item
                    label={<div>
                        <span className={"text-label"}>{t("tutores.informes.titlelink")}</span>&nbsp;&nbsp;
                        <p>{t("tutores.informes.textlink")}</p>
                    </div>}
                    name="enlace"

                >

                    <Input placeholder={t("tutores.informes.placelink")} />

                </Form.Item>
                <Form.Item  style={{ marginBottom: "0px" }}><Button  onClick={() => copyLink(t("tutores.informes.titlelink"),"enlace")} className="btnWhiteBlue  modal-question--button" htmlType="button">{t("tutores.informes.copylink")}</Button></Form.Item>

                {show &&
                <Alert
                    message={message}
                    type="success"
                    closable
                    onClose={onClose}
                />}

                <Form.Item className="buttons-pre-next">
                    <Button onClick={() => props.setShowInviteUserModal(false)} className="modal-question--button modal-question--button--cancel" htmlType="button">{t("tutores.informes.cancel")}</Button>
                </Form.Item>
            </Form>
        </Modal>
    </>

}


export default withTranslation()(InviteUser);
